import { Component, Input, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import * as moment from 'moment/moment';
import {PayoutTransactionStatusEnum} from 'app/models/transaction/payout-transaction-status.enum';
import {MenuHomeEnum} from 'app/home';
import {MenuService} from 'app/finance/finance-payout/menu-service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import {CampaignUsersService} from 'app/services/campaign-users.service';
import { LastActiveTypeModel } from 'app/models';
import { FieldTypeEnum } from 'app/models';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'campaign-users-users',
    templateUrl: './campaign-users-users.component.html',
    styleUrls: ['./campaign-users-users.component.scss'],
    providers: [MessageService]
})

export class CampaignUsersUsersComponent implements AfterViewInit {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public campaignUsersTabMenu: Array<any> = [];

    public referredList = [
        { name: 'All', value: null },
        { name: 'Yes', value: true },
        { name: 'No', value: false },
    ];

    public arrayFilterLastActiveValues: any = LastActiveTypeModel.LastActiveTypeList;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    arrayFilterStatuses: any =
        [
            {
                name: 'All'
            },
            {
                name: 'Campaign'
            },
        ];
    companyUsersArray: Array<any> = [];
    cols = [
        {
            field: 'UserId',
            header: 'User ID',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'UserId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'UserName',
            header: 'User Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'UserName',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'CreatedAt',
            header: 'Sign Up',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'CreatedAt',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'UserId',
            header: 'User Tag',
            width: '10%',
            fieldType: FieldTypeEnum.Dropdown,
            model: 'UserId',
            placeholder: 'Type here',
            options: this.arrayFilterStatuses,
            action: (rowData: any) => this.showConfirmDialog(rowData),
            active: false
        },
        {
            field: 'TotalSpend',
            header: 'Total Spend',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'TotalSpend',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'CompletedDeliveryOrderCount',
            header: 'Completed',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'CompletedDeliveryOrderCount',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'IsReferred',
            header: 'Referred?',
            width: '10%',
            fieldType: FieldTypeEnum.Dropdown,
            model: 'IsReferred',
            options: this.referredList,
            placeholder: 'Type here',
            active: false        },
        {
            field: 'LastActive', header: 'Last Active', width: '10%',
            fieldType: FieldTypeEnum.Dropdown, model: 'lastActiveTypeObj',
            options: this.arrayFilterLastActiveValues, placeholder: 'Please Select', take: 'obj'
        },
        {
            field: 'AddedAt',
            header: 'Added to Company',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'AddedAt',
            placeholder: 'Type here',
            active: false
        },
    ];
    rowsPerPage: number = 13;
    totalRecords: number = -1;
    fieldTypeEnum = FieldTypeEnum;
    paginator: Paginator = new Paginator();
    visibleTransactionsFilter: boolean = false;
    filterObj: any = {
        startDate: null,
        endDate: null,
        digitType: null,
        payService: null
    };
    txnHeaderSearch: any = {
        UserId: null,
        UserName: null,
        CreatedAt: null,
        TotalSpend: null,
        CompletedDeliveryOrderCount: null,
        IsReferred: null,
        lastActiveTypeObj: null,
        AddedAt: null,
    };
    first: number = 0;
    sortField: string | string[] = 'Id';
    sortOrder: number = -1;
    loading: boolean = false;
    searchTimer: number = 0;
    showCustomerDetails: boolean = false;
    selectedTransaction: any;
    menuHomeEnumActive: MenuHomeEnum = MenuHomeEnum.CampaignUsers_Users;

    tableName: string = EditTableConfig.CAMPAIGN_USERS_USERS;
    selectedColumns: any[] = [];
    displayConfirmDialog: boolean = false;
    customerId!: number;

    constructor(
        private messageService: MessageService,
        private campaignUsersService: CampaignUsersService,
        public configService: ConfigService,
        private menuService: MenuService,
        private cdRef: ChangeDetectorRef) {
            this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }
    }

    getMenuHomeName(): string {
        return this.campaignUsersTabMenu.find((item: any) => item.value === this.menuHomeEnumActive)?.name;
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.callGridTitles(skip);
    }

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'Id') {
                this.txnHeaderSearch.id = event.target.value;
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    getCompanyUsers(skip: number) {
        const dto = {
            UserId: this.txnHeaderSearch.UserId ? this.txnHeaderSearch.UserId : null,
            UserName: this.txnHeaderSearch.UserName ? this.txnHeaderSearch.UserName : null,
            CreatedAt: this.txnHeaderSearch.CreatedAt ? moment(this.txnHeaderSearch.CreatedAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            TotalSpend: this.txnHeaderSearch.TotalSpend ? this.txnHeaderSearch.TotalSpend : null,
            CompletedDeliveryOrderCount: this.txnHeaderSearch.CompletedDeliveryOrderCount ? this.txnHeaderSearch.CompletedDeliveryOrderCount : null,
            IsReferred: this.txnHeaderSearch.IsReferred ? this.txnHeaderSearch.IsReferred : null,
            LastActiveType: (this.txnHeaderSearch.lastActiveTypeObj) ? this.txnHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.txnHeaderSearch.lastActiveTypeObj && this.txnHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.txnHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            AddedAt: this.txnHeaderSearch.AddedAt ? this.txnHeaderSearch.AddedAt : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.loading = true;
        this.campaignUsersService.getCompanyUsers(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.paginator.Items = [];
                this.paginator.Items.push(...data.CompanyUsers);
                this.companyUsersArray = this.formatCompanyUsers(data.CompanyUsers);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    formatCompanyUsers(companyUsers: any): any {
        companyUsers.map((item: any) => {
            item.CreatedAt = moment(Utils.utcToLocaleString(item.CreatedAt)).format('DD MMM yyyy hh:mm');
            item.LastActiveAt = item.LastActiveAt ? moment(Utils.utcToLocalDate(item.LastActiveAt)).format('DD MMM yyyy hh:mm') : '';
            item.AddedAt = item.AddedAt ? moment(Utils.utcToLocalDate(item.AddedAt)).format('DD MMM yyyy hh:mm') : '';
            item.IsReferred = item.IsReferred ? 'Yes' : 'No';
            return item;
        });
        return companyUsers;
    }

    clickChangeMenuHomeActive(value: MenuHomeEnum) {
        this.menuService.changeMenuHomeEnumActive(value);
        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    getStatusStyles(status: number): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case PayoutTransactionStatusEnum.Completed:
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case PayoutTransactionStatusEnum.Pending:
                backgroundColor = '#FFEFCC';
                textColor = '#FFB100';
                break;
            case PayoutTransactionStatusEnum.Processing:
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    onSelectionChange(event: any) {
        this.selectedTransaction = event?.data;
    }

    handleHideTransactionInfo() {
        this.showCustomerDetails = false;
    }

    handleShowCustomerDetail(transaction: any) {
        if (this.displayConfirmDialog) {
            return;
        }
        this.selectedTransaction = transaction;
        this.showCustomerDetails = true;
    }

    changedVisibleCustomerDetailEmit(value: any) {
        this.showCustomerDetails = value;
        this.getCompanyUsers(0);
    }

    callGridTitles(skip: number) {
        this.getCompanyUsers(skip);
    }

    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    confirmAction() {
        this.addOrRemoveUserToCampany();
    }

    addOrRemoveUserToCampany() {
        const dto = {
            UserId: this.customerId
        };
        this.campaignUsersService.addOrRemoveUserToCampany(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User updated' });
                this.getCompanyUsers(0);
                this.displayConfirmDialog = false;
            })
            .catch(err => {
                this.displayConfirmDialog = false;
                throw err;
            });
    }

    showConfirmDialog(object: any) {
        this.customerId = object.UserId;
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }

    changeConfirmDialogVisibility() {
        this.displayConfirmDialog = !this.displayConfirmDialog;
    }
}

class Paginator {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
}
